import { render, staticRenderFns } from "./team_settings.vue?vue&type=template&id=178fb60a&scoped=true"
import script from "./team_settings.vue?vue&type=script&lang=js"
export * from "./team_settings.vue?vue&type=script&lang=js"
import style0 from "./team_settings.vue?vue&type=style&index=0&id=178fb60a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "178fb60a",
  null
  
)

export default component.exports